/* NAVI(fitpeak.co/apps/navi)でAIが作ったホームジムの「購入一覧」へ、公式サイトのどのページからでも戻れるボタン。
   NAVIが購入一覧を作ると、クッキー fp_myplan（Domain=.fitpeak.co, 30日）に
   encodeURIComponent(JSON.stringify({ n: 点数, t: 合計円, u: 更新時刻 })) を書く。
   これがあるときだけ右下に丸いボタンを出し、押すと /apps/navi?myplan=1 を開く。
   下部に固定バー（公式LINEの追従バー・商品ページのカートボタン等）が出ている間は、その上へ持ち上げる。
   読み込み元: snippets/fp-myplan-fab.liquid（layout/theme.liquid から）。テスト: scripts/test/myplan-fab.test.cjs */
(function () {
  var URL_MYPLAN = '/apps/navi?myplan=1';
  var GAP = 12;
  // 画面下に固定で出る既存のバー。増えたらここに足す。
  var BARS = '.fpl-sticky,.fpb-sticky,.cs-sticky,.fpp-sticky,.csp-sticky,.csl-sticky,.bb-next,.gd-compare-bar,#shopify-chat,#ShopifyChat,.shopify-chat';

  function parse(cookie) {
    var m = /(?:^|;\s*)fp_myplan=([^;]*)/.exec(String(cookie || ''));
    if (!m || !m[1]) return null;
    try {
      var o = JSON.parse(decodeURIComponent(m[1]));
      if (!o || typeof o !== 'object' || Array.isArray(o)) return null;
      if (typeof o.n !== 'number' || !isFinite(o.n) || o.n <= 0) return null;
      return { n: Math.floor(o.n), t: typeof o.t === 'number' && isFinite(o.t) ? o.t : null, u: o.u };
    } catch (e) { return null; }
  }

  function label(p) {
    var s = p.n + '点';
    if (typeof p.t === 'number' && isFinite(p.t)) s += '・合計¥' + Math.round(p.t).toLocaleString('ja-JP');
    return 'あなたのホームジムの購入一覧を開く(' + s + ')';
  }

  // bars: 画面座標の箱の配列。ボタンの横幅(fab.left〜fab.right)と重なり、画面下に見えているものだけ数える。
  function lift(bars, vh, fab) {
    var up = 0;
    for (var i = 0; i < bars.length; i++) {
      var b = bars[i];
      if (!b || b.bottom - b.top <= 0) continue;
      if (b.top >= vh) continue; // 画面の下に隠れている
      if (b.bottom < vh * 0.6) continue; // 画面下に固定されたものではない
      if (b.right <= fab.left || b.left >= fab.right) continue; // 横に重ならない
      up = Math.max(up, vh - b.top);
    }
    return Math.min(Math.round(up), Math.round(vh * 0.5));
  }

  window.fpMyplan = { parse: parse, label: label, lift: lift };

  var doc = document;
  if (!doc.body && doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', start); return; }
  start();

  function start() {
    var el = null, raf = 0, timer = 0;

    function render() {
      var p = parse(doc.cookie);
      if (!p) { if (el) { el.remove(); el = null; } return; }
      if (!el) {
        el = doc.createElement('a');
        el.className = 'fp-myplan-fab';
        el.href = URL_MYPLAN;
        el.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 4h2.2l2.1 10.2a1.6 1.6 0 0 0 1.6 1.3h8.4a1.6 1.6 0 0 0 1.6-1.2L21 8H6.1"/><path d="M10 11h7"/><circle cx="10" cy="19.5" r="1.4"/><circle cx="17" cy="19.5" r="1.4"/></svg><span class="fp-myplan-fab__n" aria-hidden="true"></span>';
        doc.body.appendChild(el);
      }
      el.setAttribute('aria-label', label(p));
      el.title = label(p);
      el.querySelector('.fp-myplan-fab__n').textContent = p.n > 99 ? '99+' : String(p.n);
      place();
    }

    function place() {
      raf = 0;
      if (!el) return;
      var vh = window.innerHeight || doc.documentElement.clientHeight;
      var r = el.getBoundingClientRect();
      var boxes = [];
      var list = doc.querySelectorAll(BARS);
      for (var i = 0; i < list.length; i++) {
        var cs = window.getComputedStyle(list[i]);
        if (cs.display === 'none' || cs.visibility === 'hidden' || +cs.opacity === 0) continue;
        boxes.push(list[i].getBoundingClientRect());
      }
      var up = lift(boxes, vh, { left: r.left, right: r.right });
      el.style.bottom = up > 0 ? (up + GAP) + 'px' : '';
    }

    function soon() { if (!raf) raf = window.requestAnimationFrame(place); }
    // 固定バーは transform で 0.3〜0.45秒かけて出入りするので、落ち着いた後にもう一度測る。
    function later() { clearTimeout(timer); timer = setTimeout(place, 500); }

    render();
    setTimeout(place, 1200);
    setTimeout(place, 3500);
    window.addEventListener('scroll', function () { if (el) { soon(); later(); } }, { passive: true });
    window.addEventListener('resize', function () { if (el) soon(); });
    doc.addEventListener('click', function () { if (el) later(); }, true);
    // バーの出入り（transform の transition）が終わった時点でも測り直す。
    doc.addEventListener('transitionend', function (e) {
      if (el && e.target && e.target.matches && e.target.matches(BARS)) place();
    }, true);
    // 戻る/進む（bfcache）やタブ復帰時は、NAVI側で一覧が変わっているかもしれないので読み直す。
    window.addEventListener('pageshow', function (e) { if (e.persisted) render(); });
    doc.addEventListener('visibilitychange', function () { if (doc.visibilityState === 'visible') render(); });
  }
})();
